import AATLogo from '@/assets/branding/aboveallthings/above-all-things-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#2B2A70',
  brand_primary_hover: '#212047',
  brand_primary_highlight: '#4B49C6',
  brand_primary_mid: '#343390',
  brand_primary_dark: '#080813',
  brand_secondary: '#1C1A33',
  brand_accent_start: '#32308a',
  brand_accent_end: '#6A42D8',
  brand_accent_light_start: '#e8e7ff',
  brand_accent_light_end: '#EFE8FF',
  brand_complementary_accent: 'rgb(188,191,34)',
  brand_auth_gradient_mid: '#1C1A33',
  brand_auth_gradient_end: '#080813',
  brand_auth_warp_mid: '#343390',
};

export default {
  name: 'Above all Things',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AATLogo,
  colors,
};
